// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1fd-9","tabsBox":"styles_tabsBox__817a6","createButton":"styles_createButton__3tZct"};